module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      switch (this.registrationStep.get("currentStep")) {
        case "chooseMethod":
          $o.push("<a class='back-button button disabled js-back medium secondary' disabled='disabled'>Back</a>");
          if (this.registrationStep.get("showSkip")) {
            $o.push("<a class='button js-review-tab medium transparent'>Skip to review</a>");
          }
          $o.push("<a class='button js-next medium primary'>Next</a>");
          break;
        case "addProject":
          $o.push("<a class='back-button button js-back medium secondary'>Back</a>\n<a class='button js-next medium primary'>Next</a>");
          break;
        case "import":
          $o.push("<a class='back-button button disabled js-back medium secondary' disabled='disabled'>Back</a>\n<a class='button disabled js-next medium primary' disabled='disabled'>Next</a>");
          break;
        case "review":
          $o.push("<a class='back-button button js-back medium secondary'>Add more projects</a>\n<a class='button js-next medium primary' href='" + ($e($c(this.addSkillsUrl))) + "'>Next</a>");
      }
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/projects/templates/registration_actions.js.hamlc
// module id = 1459
// module chunks = 2